import { useInfiniteQuery } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { MY_REVIEWS_KEY } from './review-query-keys';

/** 내 후기 목록(myReviews.list) — 커서 기반 무한 목록. direction 을 피하려 TanStack 훅을 직접 쓴다(use-product-reviews-query 참고). */
export const useMyReviewsQuery = () => {
  const utils = trpc.useUtils();
  return useInfiniteQuery({
    queryKey: [MY_REVIEWS_KEY],
    queryFn: ({ pageParam }) => utils.client.myReviews.list.query({ cursor: pageParam }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
  });
};
